import * as R from 'ramda'
import {
  CreateInvitation,
  reqCreateInvitation,
  GetUserInformation,
  reqGetUserInformation,
  DeleteInvitation,
  reqDeleteInvitation,
  GetInvitations,
  reqGetInvitations,
  GetInvitedContacts,
  reqGetInvitedContacts,
} from '@weblite/ts-action/invitation'
import {
  showExceedsCapacityToInviteSnackbar,
  showForbiddenToInviteSnackbar,
  showNoOneInvitedErrorSnackbar,
  showSuccessfullyInvitedSnackbar,
} from '$comp/snackbars'
import hostConf from '$config/frontend'
import { request } from '$setup/ws'
import { t } from '$i18n'
import { invitationStorage } from '$logic/invite/storage'
import { normalizePhone, toHumanReadablePhone } from '$func/phone'
import { isPhoneOrTablet } from '$func/environmentInfo'
import { shareText } from '$helper/functions/share-api'
import { toLocale } from '$func/text'

export async function inviteViaPhoneNumber(
  phoneNumbers: string[],
  canInvite: boolean,
) {
  const uniqPhoneNumbers = R.uniq(phoneNumbers)
  const normalizedPhoneNumber = uniqPhoneNumbers.map(normalizePhone)

  const res = await request<CreateInvitation>(
    reqCreateInvitation({
      phoneNumber: normalizedPhoneNumber,
      canInvite,
    }),
  )

  if (res.error) {
    if (res.error.code === 'FORBIDDEN') showForbiddenToInviteSnackbar()
    else if (res.error.code === 'EXCEEDS_CAPACITY')
      showExceedsCapacityToInviteSnackbar()
    else showNoOneInvitedErrorSnackbar()

    return
  }

  const {
    invitedPhones,
    alreadyInvitedPhones,
    invalidPhones,
    registeredPhones,
  } = res.payload

  if (
    invitedPhones?.length > 0 ||
    alreadyInvitedPhones?.length > 0 ||
    registeredPhones?.length > 0
  ) {
    const invitedCount =
      (invitedPhones.length || 0) + (alreadyInvitedPhones?.length || 0)
    const registeredCount = registeredPhones?.length || 0

    showSuccessfullyInvitedSnackbar(
      invitedCount ? toLocale(invitedCount) : '',
      registeredCount ? toLocale(registeredCount) : '',
    )

    if (isPhoneOrTablet) {
      const text =
        normalizedPhoneNumber.length === 1
          ? t('invite.oneUserSms')(
              toHumanReadablePhone(normalizedPhoneNumber[0]),
            )
          : t('invite.sms')
      const { shareable, onShare } = shareText(text)
      if (shareable) onShare()
    }
  } else showNoOneInvitedErrorSnackbar()
}

export async function getInvitations() {
  const res = await request<GetInvitations>(reqGetInvitations({}))
  if (res.error) throw new Error(res.error.message.toString())
  return res.payload
}
export async function deleteInvitation(phoneNumber: string) {
  const res = await request<DeleteInvitation>(
    reqDeleteInvitation({ phoneNumber }),
  )
  // if (res.error) {
  // }
}

export async function syncInvitationInfo() {
  if (!hostConf.HAS_INVITATION) return
  const syncInvitation = async () => {
    const invitationDB = invitationStorage.get()
    if (invitationDB)
      return {
        done: false,
        reason: `already-set-invitation: ${invitationDB}`,
      }

    const res = await request<GetUserInformation>(reqGetUserInformation({}))
    if (res.error) return { done: false, reason: res.error.message }

    await invitationStorage.set(res.payload)
    return { done: true }
  }

  const { done, reason } = await syncInvitation()
  if (!done) analite('SYNC_INVITATION_FAILED', { reason })
}

export function getMyInviter() {
  const invitationDB = invitationStorage.get()
  if (!invitationDB) return ''
  return invitationDB.inviter
}
export function getCanInvite() {
  const invitationDB = invitationStorage.get()
  if (!invitationDB) return false
  return invitationDB.canInvite
}

export async function getInvitedContacts() {
  const res = await request<GetInvitedContacts>(reqGetInvitedContacts({}))
  if (res.error) return [] as string[]
  return res.payload.phoneNumbers
}
